import {Injectable, TemplateRef} from '@angular/core';
import {Edge, IGraphNode, Node} from '../modules/graph-konva/models/graph-kn.model-interfaces';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {CrmService} from './api/crm.service';
import {AlertService} from './notify/alert.service';
import {BoardTableModel, TaskBoardModel} from '../models/tasktable.model';
import {TaskServiceService} from './task-service.service';
import {ModalService} from './modal/modal.service';
import {MemberService} from './member.service';
import {TranslateService} from '@ngx-translate/core';
import {GraphKnDataService} from '../modules/graph-konva/services/graph-kn.data.service';
import { IStatusEdge } from '../models/graph.model';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class GraphServiceService {
    public subBoardEdges = new Subject<IStatusEdge[]>();
    public deleteStatusNode: TemplateRef<any>;

    public svgIcons = {
        selectedSvg: {
            class: null,
            svg1: null,
            svg2: null,
        },
        allSvg: [
            {
                class: 'bi bi-alarm',
                svg1: 'M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5z',
                svg2: 'M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1h-3zm1.038 3.018a6.093 6.093 0 0 1 .924 0 6 6 0 1 1-.924 0zM0 3.5c0 .753.333 1.429.86 1.887A8.035 8.035 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5zM13.5 1c-.753 0-1.429.333-1.887.86a8.035 8.035 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1z',
                link: '../../../assets/images/icons/alarm.svg',
            },
            {
                class: 'bi bi-archive',
                svg1: 'M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z',
                link: '../../../assets/images/icons/archive.svg',
            },
            {
                class: 'bi bi-at',
                svg1: 'M13.106 7.222c0-2.967-2.249-5.032-5.482-5.032-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.43.199-1.354.328-2.29.328-2.926 0-4.813-1.88-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.416 2.769-.492 0-.772-.28-.772-.76V5.206H8.923v.834h-.11c-.266-.595-.881-.964-1.6-.964-1.4 0-2.378 1.162-2.378 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.11c.081.67.703 1.148 1.503 1.148 1.572 0 2.57-1.415 2.57-3.643zm-7.177.704c0-1.197.54-1.907 1.456-1.907.93 0 1.524.738 1.524 1.907S8.308 9.84 7.371 9.84c-.895 0-1.442-.725-1.442-1.914z',
                link: '../../../assets/images/icons/at.svg',
            },
            {
                class: 'bi bi-asterisk',
                svg1: 'M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z',
                link: '../../../assets/images/icons/asterisk.svg',
            },
            {
                class: 'bi bi-bar-chart',
                svg1: 'M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5v12h-2V2h2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z',
                link: '../../../assets/images/icons/bar-chart.svg',
            },
            {
                class: 'bi bi-bar-chart-steps',
                svg1: 'M.5 0a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 .5 0zM2 1.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1z',
                link: '../../../assets/images/icons/bar-chart-steps.svg',
            },
            {
                class: 'bi bi-bell',
                svg1: 'M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z',
                link: '../../../assets/images/icons/bell.svg',
            },
            {
                class: 'bi bi-box-seam',
                svg1: 'M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2l-2.218-.887zm3.564 1.426L5.596 5 8 5.961 14.154 3.5l-2.404-.961zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z',
                link: '../../../assets/images/icons/box-seam.svg',
            },
            {
                class: 'bi bi-bricks',
                svg1: 'M0 .5A.5.5 0 0 1 .5 0h15a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H14v2h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H14v2h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H2v-2H.5a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 .5 6H2V4H.5a.5.5 0 0 1-.5-.5v-3zM3 4v2h4.5V4H3zm5.5 0v2H13V4H8.5zM3 10v2h4.5v-2H3zm5.5 0v2H13v-2H8.5zM1 1v2h3.5V1H1zm4.5 0v2h5V1h-5zm6 0v2H15V1h-3.5zM1 7v2h3.5V7H1zm4.5 0v2h5V7h-5zm6 0v2H15V7h-3.5zM1 13v2h3.5v-2H1zm4.5 0v2h5v-2h-5zm6 0v2H15v-2h-3.5z',
                link: '../../../assets/images/icons/bricks.svg',
            },
            {
                class: 'bi bi-briefcase',
                svg1: 'M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z',
                link: '../../../assets/images/icons/briefcase.svg',
            },
            {
                class: 'bi bi-buildings',
                svg1: 'M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z',
                svg2: 'M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z',
            },
            {
                class: 'bi bi-calendar-date',
                svg1: 'M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z',
                svg2: 'M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z',
                link: '../../../assets/images/icons/calendar-date.svg',
            },
            {
                class: 'bi bi-camera',
                svg1: 'M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z',
                svg2: 'M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z',
                link: '../../../assets/images/icons/camera.svg',
            },
            {
                class: 'bi bi-cash-stack',
                svg1: 'M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
                svg2: 'M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z',
                link: '../../../assets/images/icons/cash-stack.svg',
            },
            {
                class: 'bi bi-chat-dots',
                svg1: 'M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
                svg2: 'm2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 0 1-.524 2.318l-.003.011a10.722 10.722 0 0 1-.244.637c-.079.186.074.394.273.362a21.673 21.673 0 0 0 .693-.125zm.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6c0 3.193-3.004 6-7 6a8.06 8.06 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a10.97 10.97 0 0 0 .398-2z',
                link: '../../../assets/images/icons/chat-dots.svg',
            },
            {
                class: 'bi bi-check2-all',
                svg1: 'M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l7-7zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0z',
                svg2: 'm5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708z',
                link: '../../../assets/images/icons/check2-all-green.svg',
            },
            {
                class: 'bi bi-easel',
                svg1: 'M8 0a.5.5 0 0 1 .473.337L9.046 2H14a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1.85l1.323 3.837a.5.5 0 1 1-.946.326L11.092 11H8.5v3a.5.5 0 0 1-1 0v-3H4.908l-1.435 4.163a.5.5 0 1 1-.946-.326L3.85 11H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4.954L7.527.337A.5.5 0 0 1 8 0zM2 3v7h12V3H2z',
                link: '../../../assets/images/icons/easel.svg',
            },
            {
                class: 'bi bi-pen',
                svg1: 'm13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z',
                link: '../../../assets/images/icons/pen.svg',
            },
        ],
    };

    public statuses: {
        in: (Node)[],
        out: (Node )[],
        availableIn: (Node)[],
        availableOut: (Node)[]
    } = {
        in: [],
        out: [],
        availableIn: [],
        availableOut: [],
    };

    public selectNode: Node | null;
    public isSuccessful = false;
    public isUniversal = false;
    public toArchive = false;
    public edges: IStatusEdge[] = [];
    public nodes: IGraphNode[] = [];
    public selectedStatus: Node = null;
    public selectedStatus1: Node = null;
    public optionBoard: TaskBoardModel;
    public copyNodes: Node[] = [];
    public deleteStatus:IGraphNode|null = null;

    public isLockButton = false;

    constructor(
        public crmService: CrmService,
        public alert: AlertService,
        public taskService: TaskServiceService,
        public modalService: ModalService,
        protected memberService: MemberService,
        protected translate: TranslateService,
        private graphKnDataService: GraphKnDataService
    ) {
    }

    getLinkedStatues(node: IGraphNode) :{
        statuses:{in:IGraphNode[],out:IGraphNode[]},
        edges:IStatusEdge[]
    } {
        const linkedEdges = {
            in: this.edges.filter(edge => edge.target.toString() === node.id.toString()).map(el=>el.source.toString()),
            out: this.edges.filter(edge => edge.source.toString() === node.id.toString()).map(el=>el.target.toString()),
        };
        let linkedStatuses = {
            in :this.nodes.filter(node => linkedEdges.in.includes(node.id.toString())),
            out:this.nodes.filter(node => linkedEdges.out.includes(node.id.toString())),
        }
        return {statuses:linkedStatuses,edges:this.edges}
    }

    getAvailableStatuses( node: IGraphNode, fullSet:boolean = false) :{in:IGraphNode[],out:IGraphNode[]} {
        let availableStatuses:{in:IGraphNode[],out:IGraphNode[]} = {in:[],out:[]}
        for (let status of this.nodes) {
            if ( 
                (status.id.toString() !== node.id.toString() || fullSet === true) 
                && !status.bp_status_data?.is_archive 
                && !status.bp_status_data?.data.is_universal     
            ) {
                availableStatuses.in.push(status);
                availableStatuses.out.push(status);
            }
        }
        return availableStatuses
    }
    async selectBoard(board: TaskBoardModel | BoardTableModel, reload: boolean, generateGraph: boolean = true): Promise<any> {
        return new Promise(resolve => {
            this.optionBoard = null;
            this.taskService.getBoard(board.alias, reload).then(res => {
                this.subBoardEdges.next(res.board.status_edges)
                this.optionBoard = structuredClone(res.board);
                resolve(this.optionBoard);
                generateGraph ? this.generateGraph() : null;
            });
        });
    }

    generateGraph(): void {
        this.nodes = [];
        this.edges = [];
        for (const status of this.optionBoard.status_node_settings_of_member) {
            const element:IGraphNode = {
                id: status.status_node.id as any,
                label: status.status_node.label,
                nodeType:'BPStatus',
                dimension:{width:0,height:0},
                position:{x:0,y:0},
                bp_status_data: status.status_node,
            };
            status.status_node.is_hidden = status.is_hidden;

            const nodeSettings = this.optionBoard.status_node_settings_of_member.filter(
                x => x.status_node.id === status.status_node.id,
            )[0];
            this.nodes.push(element);
        }

        this.edges = this.optionBoard.status_edges;
        for (const element of this.edges) {
            element.id = element.id;
            element.source = element.source;
            element.target = element.target;
        }
        this.graphKnDataService.generateGraphDataBP$.next({nodes: this.nodes, edges: this.edges})
    }

    getStatusMembers(): void {
        if (!this.selectNode) {
            return;
        }
        let membersGuids: string[] = [];
        Object.values(this.selectNode.data.roles).forEach((role: string[]) => {
            const guidsMapping = role.map((guid: any) => {
                if (typeof guid !== 'string') {
                    guid = guid.guid;
                }

                return guid;
            });
            membersGuids = membersGuids.concat(guidsMapping);
        });

        this.memberService.memberGuidsHandler(membersGuids).then(members => {
            Object.keys(this.selectNode.data.roles).forEach(roleKey => {
                this.selectNode.data.roles[roleKey] = this.selectNode.data.roles[roleKey].map(guid => {
                    if (typeof guid === 'string') {
                        return members.find(member => member.guid === guid);
                    } else {
                        return guid;
                    }
                });
            });
        });
    }
/*     getStatusMembers2(): Observable<boolean> {
        if (!this.selectNode) {
            return of(true);
        }
        let membersGuids: string[] = [];
        Object.values(this.selectNode.data.roles).forEach((role: string[]) => {
            const guidsMapping = role.map((guid: any) => {
                if (typeof guid !== 'string') {
                    guid = guid.guid;
                }

                return guid;
            });
            membersGuids = membersGuids.concat(guidsMapping);
        });

       return from(this.memberService.memberGuidsHandler(membersGuids)).pipe(
        map(members => {
            Object.keys(this.selectNode.data.roles).forEach(roleKey => {
                this.selectNode.data.roles[roleKey] = this.selectNode.data.roles[roleKey].map(guid => {
                    if (typeof guid === 'string') {
                        return members.find(member => member.guid === guid);
                    } else {
                        return guid;
                    }
                });
            });
            return true
        })
    
    );
    } */

    async createDependencies(prepared: any = null, modal: NgbModalRef = null): Promise<any> {

        if (!prepared && !this.selectedStatus && !this.selectedStatus.id) {
            return this.alert.setAlert(this.translate.instant('ALERTS.SET_OUT_STATUS'), 'blue');
        }
        if (!prepared && !this.selectedStatus1 && !this.selectedStatus1.id) {
            return this.alert.setAlert(this.translate.instant('ALERTS.SET_IN_STATUS'), 'blue');
        }

        const data = {
            source_id: prepared ? prepared.source : this.selectedStatus.id,
            target_id: prepared ? prepared.target : this.selectedStatus1.id,
        };

        this.isLockButton = true;

        this.crmService.addEdge(this.optionBoard.alias, data).subscribe({
            next: res => {
                this.selectBoard(res.board, true);
                if (modal) {
                    modal.close();
                }
                this.selectedStatus = null;
                this.selectedStatus1 = null;
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                this.isLockButton = false;
            }, error: error => {
                this.isLockButton = false;
                this.alert.setAlert(error.message, 'blue');
            },
        });
    }

    async createNodeStatus(title, description, isUniversal, color, isSuccessful, modal: NgbModalRef): Promise<any> {
        return new Promise(resolve => {
            const source = [];
            const target = [];

            for (const element of this.statuses.in) {
                source.push(element.id);
            }

            for (const element of this.statuses.out) {
                target.push(element.id);
            }

            const data = {
                label: title,
                description: description,
                target_ids: isUniversal ? null : target.toString(),
                source_ids: isUniversal ? null : source.toString(),
                is_successful: isSuccessful,
                is_universal: isUniversal,
                data: JSON.stringify({
                    backgrCol: color,
                    svg: this.svgIcons.selectedSvg,
                }),
            };

            this.isLockButton = true;
            this.crmService.addNode(this.optionBoard.alias, data).subscribe({
                next: res => {
                    this.selectBoard(res.board, true).then(result => {
                        resolve(result.status_node_settings_of_member.filter(x => x.status_node.label === title)[0]);
                    });
                    modal.close();
                    this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                    this.selectedStatus = null;
                    this.svgIcons.selectedSvg.class = '';
                    this.svgIcons.selectedSvg.svg1 = '';
                    this.svgIcons.selectedSvg.svg2 = '';
                    this.isLockButton = false;
                }, error: error => {
                    this.isLockButton = false;
                    this.alert.setAlert(error.message, 'blue');
                },
            });
        });
    }

    async addDependencies(isOut: boolean, isNewNode: boolean = false): Promise<any> {
        if (isOut) {
            if (this.selectedStatus) {
                this.statuses.out.push(this.selectedStatus);
            }
            this.statuses.availableOut = this.statuses.availableOut.filter(x => x.id !== this.selectedStatus.id);

            if (!isNewNode) {
                const edge = {
                    source: this.selectNode.id.toString(),
                    target: this.selectedStatus.id.toString(),
                };
                await this.createDependencies(edge);
            }
            this.selectedStatus = null;
        } else {
            if (this.selectedStatus) {
                this.statuses.in.push(this.selectedStatus);
            }
            this.statuses.availableIn = this.statuses.availableIn.filter(x => x.id !== this.selectedStatus.id);

            if (!isNewNode) {
                const edge = {
                    source: this.selectedStatus.id.toString(),
                    target: this.selectNode.id.toString(),
                };
                await this.createDependencies(edge);
            }
            this.selectedStatus = null;
        }

    }

    async deleteGraphElement(isNode: boolean = false, element): Promise<any> {
        if (isNode) {
            this.deleteStatus = element;
            this.copyNodes = Object.assign([], this.nodes.filter(x => x.id !== element.id));
            this.modalService.openTemplateModal(this.deleteStatusNode);
        } else {
            this.crmService.deleteEdge(element.id).subscribe({
                next: res => {
                    this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                    void this.selectBoard(res.board, true);
                }, error: error => {
                    this.alert.setAlert(error.message, 'blue');
                },
            });
        }
    }
  
}
